var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('SearchObject', {
    ref: "search",
    attrs: {
      "additional-params": Object.assign({
        ordering: 'name'
      }, _vm.additionalParams),
      "autofocus": _vm.autofocus,
      "base-url": _vm.baseUrl,
      "disabled": _vm.disabled,
      "requited": _vm.required,
      "hide-details": _vm.hideDetails,
      "item-text": _vm.itemText,
      "label": _vm.label || _vm.$translate('select_organization'),
      "readonly": _vm.readonly,
      "required": _vm.required,
      "value": _vm.value,
      "error-messages": _vm.errorMessages,
      "dense": _vm.dense,
      "clearable": _vm.clearable
    },
    on: {
      "input": function input($event) {
        return _vm.$emit('input', $event);
      }
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function fn(_ref) {
        var _item$entity_data;
        var item = _ref.item;
        return [item ? _c('div', {
          staticClass: "nowrap"
        }, [_c('b', [_vm._v(" " + _vm._s((_item$entity_data = item.entity_data) === null || _item$entity_data === void 0 ? void 0 : _item$entity_data.name))]), _c('span', {
          staticClass: "text-caption"
        }, [_vm._v(" (" + _vm._s(item.first_name) + " " + _vm._s(item.last_name) + ") ")])]) : _vm._e()];
      }
    }])
  });

}
var staticRenderFns = []

export { render, staticRenderFns }